export const enslaved = {
  // These entries will be unlocked in no particular order
  progress: {
    hintsUnlocked: {
      id: 0,
      hint: "Безымянные хотят помочь, но помощь занимает время.",
      condition: () => `Проведено более ${formatInt(5)} часов реального времени внутри Реальности без её прохождения;
        время снаружи Реальности считается как за ${formatPercents(0.4)}. Таймер начинается как только
        Реальность разблокирована, но накапливается непрерывно.`,
    },
    ec1: {
      id: 1,
      hint: "Это странны, перк Автоматических Вечных Челленджей имеет некоторые проблемы.",
      condition: () => `Получено более чем ${formatInt(5)} прохождений Вечного Челленджа 1 за раз`,
    },
    feelEternity: {
      id: 2,
      hint: "Бесконечность кажется более преодолённой, чем обычно, в этой Реальности, можно ли это починить?",
      condition: "Попытался Починить Бесконечность, но вместо этого нашел и кликнул кнопку ПОЧУВСТВОВАТЬ ВЕЧНОСТЬ",
    },
    ec6: {
      id: 3,
      hint: `Некоторые Челленджи сложнее, но также дают бонус к чему-то взамен. Интересно, существует ли Челлендж
        который просто лучше чем обычно здесь.`,
      condition: () => `Вошел в Вечный Челлендж 6 вновь после прохождения его ${formatInt(5)} раз, для того чтобы
        использовать его дешевые Галактики Репликантов`,
    },
    c10: {
      id: 4,
      hint: "Существует ли способ получать Галактики Антиматерии без 8ых Измерений Антиматерии?",
      condition: "Использовал Челлендж 10 чтобы получить больше 1 Галактики Антиматерии с 6ых Измерений Антиматерии",
    },
    secretStudy: {
      id: 5,
      hint: "Временное Исследование 12? Что это?",
      condition: () => `Нажал на секретное Временное Исследование и заработал дополнительные ${
        formatInt(100)} Временных Теорем`,
    },
    storedTime: {
      id: 6,
      hint: "Похоже, что некоторые части этой Реальности разрушаются, если подождать достаточное количество времени.",
      condition: "Разрядил, чтобы получить больше года игрового времени в этой реальности",
    },
    challengeCombo: {
      id: 7,
      hint: "Могу ли я использовать один Челлендж, чтобы обойти ограничение в другом Челлендже?",
      condition: "Вошёл в Челлендж 10, пока находится внутри Вечного Челленджа 6",
    },
  },
  // These get unlocked sequentially
  glyphHints: [
    "Глифы Бесконечности и Растяжения выглядят слишком сильно ограниченными, для того чтобы быть полезными.",
    "Глифы Мощности и Времени в особенности сильны здесь.",
    `Глифы Эффарига полезны только с правильными эффектами, но ты можешь пройти Реальность без него.
      Глиф Репликации очень полезен, но он не обязателен и не так силён как Глифы Мощности и Времени.`
  ]
};
